import { getStore } from '../store/store';

export interface HeartbeatMemorySizesMb {
    workingSetSizeMb: number | undefined;
    commitSizeMb: number | undefined;
    isProcessShared: boolean | undefined;
}

/**
 * Returns the BizChat iframe memory sizes in MB from the latest heartbeat,
 * or undefined values if no heartbeat has been received yet.
 */
export function getHeartbeatMemorySizesMb(): HeartbeatMemorySizesMb {
    const store = getStore();
    return {
        workingSetSizeMb: store.heartbeatWorkingSetSizeMb,
        commitSizeMb: store.heartbeatCommitSizeMb,
        isProcessShared: store.isProcessShared,
    };
}
